import Environment from '@di-shared/features/environment/Environment';
import Kr from '@di-shared/features/history/setting/HistorySetting/.kr';

export interface HistorySettingProps {
  vin: string;
}

export default function HistorySetting({vin}: HistorySettingProps) {
  return (
    <>
      <Environment.Kr>
        <Kr vin={vin} />
      </Environment.Kr>
    </>
  );
}
